import {Pipe, PipeTransform} from '@angular/core';
import {FreeZone} from '@domain/production-schedule/free-zone/free-zone';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePhase} from '@domain/production-schedule/production-schedule-phase.enum';
import {RestZone} from '@domain/production-schedule/rest-zone/rest-zone';

@Pipe({
  name: 'getProductionSchedulePathsAndZonesForColoredYarnSet'
})
export class GetProductionSchedulePathsAndZonesForColoredYarnSetPipe implements PipeTransform {
  public transform(productionSchedule: ProductionSchedule, coloredYarnSetIndex: number, productionSchedulePhase: ProductionSchedulePhase): (ProductionSchedulePath | RestZone | FreeZone)[] {
    const items: (ProductionSchedulePath | RestZone | FreeZone)[] = [...productionSchedule.productionSchedulePathsOfColoredYarnSets[coloredYarnSetIndex].productionSchedulePaths];

    if (productionSchedulePhase === ProductionSchedulePhase.VERIFY) {
      items.push(
        ...productionSchedule.restZones.filter((restZone: RestZone) => restZone.coloredYarnSetPathNr - 1 === coloredYarnSetIndex),
        ...productionSchedule.freeZones.filter((freeZone: FreeZone) => freeZone.coloredYarnSetPathNr - 1 === coloredYarnSetIndex)
      );
    }

    return items.sort((firstItem: {startDent: number}, secondItem: {startDent: number}) => firstItem.startDent - secondItem.startDent);
  }
}
